import React, { Select } from "formik-antd";
export function mapTimeZones(option: { name?: string; id?: number }) {
  return (
    <Select.Option value={option.name} key={option.id}>
      {option.name}
    </Select.Option>
  );
}
